(() => {
  const enhanced = new WeakSet();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const enhance = () => {
    if (!('IntersectionObserver' in window) || reducedMotion.matches || window.Shopify?.designMode) return;
    document.querySelectorAll('.lox-policy').forEach((root) => {
      if (enhanced.has(root)) return;
      enhanced.add(root);
      const sections = [...root.querySelectorAll('.lox-policy-section, .lox-policy-contact')];
      if (!sections.length) return;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.01, rootMargin: '0px 0px -40px 0px' });
      root.classList.add('lox-policy--motion');
      sections.forEach((section) => {
        section.classList.add('lox-policy-reveal');
        const bounds = section.getBoundingClientRect();
        if (bounds.top < window.innerHeight - 40 && bounds.bottom > 0) {
          section.classList.add('is-visible');
        } else {
          observer.observe(section);
        }
      });
      root.addEventListener('focusin', (event) => {
        const section = event.target.closest('.lox-policy-reveal');
        if (section) {
          section.classList.add('is-visible');
          observer.unobserve(section);
        }
      });
      reducedMotion.addEventListener('change', (event) => {
        if (!event.matches) return;
        root.classList.remove('lox-policy--motion');
        observer.disconnect();
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance, { once: true });
  } else {
    enhance();
  }
  document.addEventListener('shopify:section:load', enhance);
})();